import Link from 'next/link';
import i18n from '@/settings/i18n';

const t = i18n.init('shared');

const Help = () => (
  <Link
    href="/help"
    // eslint-disable-next-line tailwindcss/no-custom-classname
    className="fancy-underline hidden text-sm font-medium md:block"
  >
    {t`Need help?`}
  </Link>
);

export default Help;
